import flatpickr from "flatpickr";
import { Japanese } from "flatpickr/dist/l10n/ja.js";

export const init_flatpickr_form = () => {

  let dateEnd; // 終了日を格納する変数

  // --- 開始日の設定 ---
  const dateStart = flatpickr(".js-date-start", {
    locale: Japanese,
    dateFormat: "Y/m/d",
    allowInput: true,
    disableMobile: true,
    onChange: function(selectedDates, dateStr, instance) {
      if (dateEnd) {
        // 終了日のカレンダーがあれば、その最小日付を開始日に合わせる
        const target = Array.isArray(dateEnd) ? dateEnd[0] : dateEnd;
        target.set('minDate', dateStr);
      }
    }
  });

  // --- 終了日の設定 ---
  dateEnd = flatpickr(".js-date-end", {
    locale: Japanese,
    dateFormat: "Y/m/d",
    allowInput: true,
    disableMobile: true,
    onChange: function(selectedDates, dateStr, instance) {
      if (dateStart) {
        // 開始日のカレンダーがあれば、その最大日付を終了日に合わせる
        const target = Array.isArray(dateStart) ? dateStart[0] : dateStart;
        target.set('maxDate', dateStr);
      }
    }
  });
};